import classNames from 'classnames';
import Link from 'next/link';
import React from 'react';
import { SubscriptionPopup } from 'src/components/IdleSubscriptionPopup/components/SubscriptionPopup';
import { IMenuFormat } from 'src/hooks/formats';
import { useSubscription } from 'src/hooks/subscription';
import { useSubscriptionPopup } from 'src/hooks/subscriptionPopup';
import { scrollToTop } from 'src/utils/srollTo';

import { Icon, Typography } from '@sravni/react-design-system';
import { useBoolean } from '@sravni/react-utils';

import styles from '../Item/menu-item.module.scss';

interface IProps {
  item: IMenuFormat;
  onClick?: () => void;
  subscriptionPopupState: [number, (value: number) => void];
  hideMenuController: () => void;
}

export const SubscribtionMenuItem = ({ item, onClick, subscriptionPopupState, hideMenuController }: IProps) => {
  const { userEmail, handleSubscriptionClick, canUserSubscribe, isEmailEditable } = useSubscription('Попап');
  const [isVisible, setIsVisible] = useBoolean();

  const { onVisible, onHide } = useSubscriptionPopup(subscriptionPopupState);

  const handleViewModalHideMenu = () => {
    setIsVisible.on();
    hideMenuController();
  };

  if (!canUserSubscribe) return null;

  return (
    <>
      <Typography.Text
        size={14}
        strong
        className={classNames(styles.item)}
        key={`format-${item.name}`}
        onClick={onClick || scrollToTop}
      >
        {item.isExternal || !item.link ? (
          <Typography.Link
            onClick={handleViewModalHideMenu}
            color={'black'}
            href={item.url || item.link?.as || null}
            className={classNames(styles.itemLink, { [styles[`itemLink--active`]]: item.isActive })}
          >
            <Icon shape={'round'} size={16} className={styles.itemIcon}>
              {item.icon}
            </Icon>
            {item.name}
          </Typography.Link>
        ) : (
          <Link href={item.link.href} as={item.link.as}>
            <Typography.Link
              onClick={handleViewModalHideMenu}
              color={'black'}
              href={item.url || item.link?.as || null}
              className={classNames(styles.itemLink, { [styles[`itemLink--active`]]: item.isActive })}
            >
              <Icon shape={'round'} size={16} className={styles.itemIcon}>
                {item.icon}
              </Icon>
              {item.name}
            </Typography.Link>
          </Link>
        )}
      </Typography.Text>
      <SubscriptionPopup
        userEmail={userEmail}
        onSubscribe={handleSubscriptionClick}
        onVisible={onVisible}
        onHide={onHide}
        canBeVisible={isVisible}
        onClose={setIsVisible.off}
        isEmailEditable={isEmailEditable}
      />
    </>
  );
};
